<div class="member-card-container pointer" (click)="details()" [title]="'Détails ' + member.firstName + ' ' + member.lastName">
    <div class="member-card">
        <div class="member-image-col">
            <img [src]="member.profileImage || './assets/images/icons/user-default-icon.png'" [alt]="member.firstName" class="member-image" [class.full]="member.profileImage" (error)="setDefaultImage($event)">
        </div>

        <div class="member-content-col">
            <div class="col-header">
                <h3 class="member-title">{{ member.firstName + " " + member.lastName }}</h3>
                <div class="right-side">
                    <div class="status-badge">
                        <span class="status-dot" [class.public]="member.isEnabled" [class.private]="!member.isEnabled"></span>
                        <span class="status-text">{{ member.isEnabled ? 'Compte activer' : 'Compte inactive' }}</span>
                    </div>
                    <button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                        <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                    </button>
                </div>
            </div>

            <div class="member-footer">
                <p class="member-description">
                    {{ member.email }}
                </p>
                <div class="creation-date">
                    {{ member.createdAt }}
                </div>
            </div>
        </div>
    </div>

    <div class="popup-menu" *ngIf="menuOpen">
        <div class="arrow"></div>
        <ul>
            <li (click)="details()">
                <img src="./assets/images/icons/details.png" alt="View"> Details
            </li>
            <li (click)="edit()">
                <img src="./assets/images/icons/edit.png" alt="View"> Modifier
            </li>
            <li (click)="toggleVisibility()">
                <img class="lock" src="./assets/images/icons/lock-red.png" alt="Visibility"> {{ member.isEnabled ? 'Rendre inactif' : 'Rendre actif' }}
            </li>
            <li (click)="confirmDelete()" class="delete-item">
                <img src="./assets/images/icons/trash.png" alt="Delete"> Supprimer
            </li>
        </ul>
    </div>
</div>

<div class="confirmation-modal-overlay" *ngIf="showDeleteModal">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir supprimer ce member <br><strong>"{{ member.firstName + " " + member.lastName  }}"</strong> (<small>{{member.email}}</small>) ?</p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="deleteMember()">Supprimer</button>
        </div>
    </div>
</div>